import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class PTC_Boletos {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async retornaBoletos(queries = null) {
    try {
      const baseUrl = 'ptc/RetornaTitulos';
      const params = new URLSearchParams();

      if (queries) {
        if (queries.tituloNumero) {
          params.append('tituloNumero', queries.tituloNumero);
        }
        if (queries.tituloSituacao) {
          params.append('tituloSituacao', queries.tituloSituacao);
        }
        if (queries.tituloDtEmissaoDe && queries.tituloDtEmissaoAte) {
          params.append('tituloDtEmissaoDe', queries.tituloDtEmissaoDe);
          params.append('tituloDtEmissaoAte', queries.tituloDtEmissaoAte);
        }
        if (queries.notafiscalnumero) {
          params.append('notafiscalnumero', queries.notafiscalnumero);
        }
        if (queries.page) {
          params.append('page', queries.page);
        }
        if (queries.limit) {
          params.append('limit', queries.limit);
        }
      }

      const url = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;

      const result = await this.api.get(url);
      return result.data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao retornar Boletos');
    }
  }
}
